import { Appointment } from "./Appointment";
import { Car } from "./Car";
import { COMMUNICATION_CHANNELS } from "./CustomerCommunication";
import { CustomerNote } from "./CustomerNote";
import { Dealer, DealerID } from "./Dealer";
import { DealerLocation, DealerLocationID } from "./DealerLocation";

export type CustomerID = number;

export enum CUSTOMER_ROLES {
  CustomerDriver = 0,
  CustomerOwner = 1,
  CustomerContractor = 2
}

export enum CUSTOMER_TYPES {
  NotSet = 0,
  Driver = 1,
  Owner = 2,
  Contractor = 3
}

export interface Customer {
  created_on: string;
  updated_on: string;
  id: CustomerID; // Customer's ID
  meta_dms_nr: string; // Some DMS can have multiple contacts for a single customer. This field, alongside dms_nr, help to identify which contact should be referenced
  dms_nr: string; // Identifier in DMS
  last_appointment_date: string; // Last appointment this Customer was associated with
  last_disposal_at: string | null; // When the customer information was removed due to no longer being associated with recent appointments
  company: string; // Company name
  is_lease_company: boolean; // Is the company a lease company
  is_internal: boolean; // Is this customer for Internal usage
  is_internal_edited: boolean; // IsInternal was edited through Claire
  title: string; // Salutation title of the customer
  initials?: string; // Initials of the customer
  firstname: string; // First Name of the customer
  surname?: string; // Surname of the customer
  street?: string; // Street address of the customer
  house_nr?: string; // House Number of the customer
  postcode?: string; // Postcode of the customer
  place?: string; // Place of the customer
  country?: string; // Country of the customer
  block_communication: boolean; // Customer has opted for no communication
  preferred_communication_channel: COMMUNICATION_CHANNELS; // Preferred communication channel opted by the customer
  email_private?: string; // Private Email
  email_business?: string; // Business Email
  tel_business_nr?: string; // Business Landline Number
  tel_private_nr?: string; // Private Landline Number
  tel_mobile_private?: string; // Private Mobile Number
  tel_mobile_business?: string; // Business Mobile Number
  tel_mobile_private_invalid_for_whats_app?: string; // Invalid private mobile number for WhatsApp
  tel_mobile_business_invalid_for_whats_app?: string; // Invalid business mobile number for WhatsApp
  dealer_location_id: DealerLocationID; // Location Identifier of the customer
  dealer_id: DealerID; // Dealer ID of the customer
  dealer_location?: DealerLocation;
  dealer?: Dealer;
  appointments?: Appointment[];
  cars?: Car[];
  customer_type: CUSTOMER_TYPES; // Customer type
  notes?: CustomerNote[]; // List of notes of the customer
}
